import { useState, useEffect } from 'react'
import { gsap } from 'gsap'

import LoadingManager from '../../experience/Utils/LoadingManager'
import Experience from '../../experience'

/**
 * Experience loading hook
 */
const useLoading = (
  step: number,
  experience: React.MutableRefObject<Experience | undefined>
) => {
  const [loading, setLoading] = useState({
    done: false,
    progress: 0,
  })

  /**
   * THREE Loading manager
   */
  LoadingManager.onProgress = (_, loaded, total) => {
    if (!loading.done) {
      const progress = (loaded / total) * 100

      if (progress >= 100) {
        setLoading({ progress, done: true })
      } else {
        setLoading({ ...loading, progress })
      }
    }
  }

  /**
   * Control loader fading and showing the shark prompt
   */
  useEffect(() => {
    if (loading.done && step === 0) {
      gsap.to('.loader', {
        duration: 0.2,
        opacity: 0,
        display: 'none',
        onComplete: () => {
          gsap.to('#outline-container', {
            duration: 1,
            display: 'flex',
            opacity: 1,
          })
        },
      })

      const handler = (visible: boolean) => visible && gsap.killTweensOf('*')
      experience.current?.eventEmitter.on('sharkSeenEvent', handler)
    }
  }, [experience, loading.done, step])

  // useEffect(() => {
  //   // if (step === 1) document.getElementById('reverse-btn')?.click()
  // }, [step])

  return { progress: loading.progress }
}

export default useLoading
